var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    flex: true,
    'scrollbar-photo': _setup.backgroundLuminance === 'light',
    'scrollbar-photo-dark': _setup.backgroundLuminance === 'dark',
    'overflow-x-hidden': !_setup.isReadOnly,
  },attrs:{"id":"wall-container"},on:{"scroll":function($event){return _vm.$emit('scroll', $event)}}},[(_setup.xHeader)?_c(_setup.SurfaceHeader):_vm._e(),_vm._v(" "),_c(_setup.SurfacePostsGrid,{staticClass:"flex-grow",attrs:{"reaction-ids-by-post-id":_vm.reactionIdsByPostId,"comment-ids-by-post-id":_vm.commentIdsByPostId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }